import { inject, type InjectionKey } from 'vue'

export function injectStrict<T>(key: InjectionKey<T>, name: string): T {
  const value = inject(key)
  if (!value) throw new Error(`[widget] ${name} not provided — check entry.ts setup()`)
  return value
}
